import sectionCardSmokingCss from '../css-snippets/section-card-smoking';

const html = `
<style>${sectionCardSmokingCss}</style>
<div data-attribute="card-container" data-background="#ffffff" data-top-padding="true" data-bottom-padding="true" style="background-color: #ffffff">
   <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF" style="background-color: transparent;">
      <div class="wrap-card container">
         <div class="card-layout">
            <div data-attribute="card-item-content" data-order="1" class="card-left" data-style-center-y="false" style="order: 1;">
               <div data-attribute="card-content" data-background="#000000" style="background-color: #000000" class="card-content">
                  <div data-attribute="card-title" class="card-title">
                     <h2><span style="color:hsl( 0, 0%, 58% );"><strong>Smoking</strong></span><strong> </strong>&amp;<strong> </strong><span style="color:hsl( 0, 0%, 58% );"><strong>Vaping</strong></span></h2>
                  </div>
                  <div data-attribute="card-description" class="card-description">
                     <p><strong>Your lungs deserve better.</strong> Years of smoking or vaping can weaken lung function, reduce oxygen intake, and create a dependence on hand-to-mouth habits. The <strong>Inex-Air</strong> helps <strong>break the cycle</strong> by replacing unhealthy habits with a <strong>purposeful, structured breathing tool</strong> that strengthens your lungs while keeping your hands engaged.</p>
                     <p><strong>-Lung Recovery</strong> – Train your lungs to regain strength, improve capacity, and breathe easier.</p>
                     <p><strong>-Hand-to-Mouth Habit Replacement</strong> – Redirect cravings with intentional breath training.</p>
                     <p><strong>-Reduce Breathlessness</strong> – Improve airflow and endurance for easier, deeper breathing.</p>
                     <p><strong>-Track Your Progress</strong> – See real-time improvements and stay motivated.</p>
                     <p><strong>Quit the habit, rebuild your lungs, and breathe freely again.</strong> Your journey to a healthier you starts today.</p>
                  </div>
               </div>
            </div>
            <div data-attribute="card-item-image" data-order="2" class="card-right" style="order: 2;">
               <div class="wrap-img">
                 <img loading="lazy" data-attribute="card-image" class="card-image" src=https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0d98ad52729bb01e26557.webp?w=1000" alt="">
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
`;
export default html;
